import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["rows", "template", "row"]

  connect() {
    this.sync()
  }

  add(event) {
    event.preventDefault()
    this.rowsTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML)
    this.sync()
    this.dispatch("changed")
  }

  sync() {
    this.rowTargets.forEach((row) => this.syncRow(row))
    this.validateOverlaps()
    this.notifyChanged()
  }

  remove(event) {
    event.preventDefault()
    const row = event.target.closest("[data-date-range-list-target='row']")
    if (!row) return

    row.remove()
    if (this.rowTargets.length === 0) this.add(event)
    this.sync()
  }

  notifyChanged() {
    this.element.dispatchEvent(new Event("input", { bubbles: true }))
  }

  syncRow(row) {
    const startInput = row.querySelector("[data-date-range-start]")
    const endInput = row.querySelector("[data-date-range-end]")
    if (!startInput || !endInput) return

    if (startInput.value) {
      endInput.min = startInput.value
    } else {
      endInput.removeAttribute("min")
    }

    if (startInput.value && endInput.value && endInput.value < startInput.value) {
      endInput.value = ""
    }
  }

  validateOverlaps() {
    const ranges = this.rowTargets.map((row) => {
      row.classList.remove("form-field__date-range-row--invalid")
      const startInput = row.querySelector("[data-date-range-start]")
      const endInput = row.querySelector("[data-date-range-end]")

      return {
        row,
        start: startInput?.value || "",
        end: endInput?.value || ""
      }
    }).filter((range) => range.start && range.end).sort((a, b) => a.start.localeCompare(b.start))

    let hasOverlap = false
    for (let index = 1; index < ranges.length; index += 1) {
      const previous = ranges[index - 1]
      const current = ranges[index]
      if (current.start <= previous.end) {
        previous.row.classList.add("form-field__date-range-row--invalid")
        current.row.classList.add("form-field__date-range-row--invalid")
        hasOverlap = true
      }
    }

    this.element.toggleAttribute("data-overlap", hasOverlap)
  }
}
